import AddIcon from '@mui/icons-material/Add';
import {Box, Button, Typography} from '@mui/material';

export interface ExamModuleHeaderProps {
  handleOpenDialog: () => void;
}

export default function ExamModuleHeader({handleOpenDialog}: ExamModuleHeaderProps) {
  return (
    <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3}}>
      <Typography variant="h4" component="h1">
        Exam Module Management
      </Typography>
      <Button
        variant="contained"
        startIcon={<AddIcon />}
        onClick={() => handleOpenDialog()}
        sx={{bgcolor: '#1B263B', '&:hover': {bgcolor: '#0f1419'}}}
      >
        Add Module
      </Button>
    </Box>
  );
}
